import baseScmService from 'services/baseScmService';

type IHolidayData = {
  data: IHoliday[];
};

const holidayService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getHolidayList: build.query<IHolidayData, null>({
      query: () => ({
        method: 'GET',
        url: '/holidays/',
      }),
      keepUnusedDataFor: 60 * 60 * 24, // Cache data for 24 hour
    }),
  }),
  overrideExisting: false,
});

export const { useGetHolidayListQuery } = holidayService;

export default holidayService;
